// types
import type { Components, Theme } from "@mui/material";

export const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    variant: "contained",
    disableRipple: false,
    disableElevation: true,
    fullWidth: false,
    size: "medium",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 12,
      fontWeight: 600,
      textTransform: "none" as const,
      transition: theme.transitions.create(
        ["background-color", "box-shadow", "transform", "border-color"],
        {
          duration: theme.transitions.duration.short,
          easing: theme.transitions.easing.easeInOut,
        }
      ),
      "&:active": {
        transform: "scale(0.97)",
      },
    }),
    containedPrimary: ({ theme }) => ({
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
        boxShadow: `0 4px 12px 0 ${theme.palette.primary.main}30`,
      },
      "&:disabled": {
        backgroundColor: theme.palette.grey[300],
        border: "none",
        color: theme.palette.grey[500],
        boxShadow: "none",
      },
    }),
    contained: ({ theme }) => ({
      padding: theme.spacing(2, 4),
      fontSize: theme.typography.body2.fontSize,
    }),
    outlined: ({ theme }) => ({
      padding: theme.spacing(2, 4),
      borderWidth: 1.5,
      "&:hover": {
        borderWidth: 1.5,
        backgroundColor: `${theme.palette.primary.main}08`,
      },
    }),
    text: ({ theme }) => ({
      padding: theme.spacing(2, 3),
      "&:hover": {
        backgroundColor: `${theme.palette.action.hover}`,
      },
    }),
    sizeSmall: {
      padding: "6px 14px",
      fontSize: "0.8125rem",
      borderRadius: 10,
    },
    sizeLarge: {
      padding: "12px 24px",
      fontSize: "0.9375rem",
      borderRadius: 14,
    },
  },
};
